<template>
  <div class="question-repeat-dialog-container">
    <el-dialog
      width="600px"
      :visible.sync="show"
      :before-close="handleUpdateQuestion"
    >
      <div
        slot="title"
        style="text-align:center;font-size:20px;color:#606266"
        v-if="step == 'check'"
      >
        正在进行题目检查，请稍等
      </div>
      <div class="check-list" v-if="step == 'check'" v-loading="loading">
        <div class="check-item">
          <zhu-svg svg-class="check-icon" svg-name="check"></zhu-svg>
          <p class="ml-12 check-item-desc">1.选项是否有重复</p>
        </div>
        <div class="check-item">
          <zhu-svg svg-class="check-icon" svg-name="check"></zhu-svg>
          <p class="ml-12 check-item-desc">2.题干是否和已有题库重复</p>
        </div>
      </div>
      <div v-if="step == 'pass'" class="pass-container">
        <div class="pass-icon-bg">
          <zhu-svg svg-class="gou-icon" svg-name="gou" fill="#fff"></zhu-svg>
        </div>
        <div class="pass-desc">提交成功</div>
      </div>
      <div v-if="step == 'reject'" class="reject-container">
        <div class="reject-icon-bg">
          <zhu-svg
            svg-class="close-icon"
            svg-name="close"
            fill="#fff"
          ></zhu-svg>
        </div>
        <div class="reject-desc">提交失败，请修改</div>
        <p
          class="reject-reason"
          v-if="dialogInfo.option && dialogInfo.option.length"
        >
          去掉特殊字符后，选项 {{ dialogInfo.option[0] }} 和选项
          {{ dialogInfo.option[1] }} 重复
        </p>
        <p
          class="reject-reason"
          v-if="dialogInfo.stem && dialogInfo.stem.length"
        >
          去掉特殊字符后，题干和题库中已有题目相似度达到90%
        </p>
        <p
          class="reject-example"
          v-if="dialogInfo.stem && dialogInfo.stem.length"
        >
          题库案例：{{ dialogInfo.stem[0].stem }}
        </p>
        <el-button
          class="mt-12"
          size="medium"
          type="primary"
          @click="handleUpdateQuestion"
          >修改题目</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    repeatDialog: {
      type: Boolean,
      default: false
    },
    dialogStep: {
      type: String,
      default: "check"
    },
    dialogLoading: {
      type: Boolean,
      default: false
    },
    dialogInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      show: false,
      step: "check",
      loading: false
    };
  },
  watch: {
    repeatDialog(val) {
      this.show = val;
    },
    dialogStep(val) {
      this.step = val;
    },
    dialogLoading(val) {
      this.loading = val;
    }
  },
  created() {},
  methods: {
    handleUpdateQuestion() {
      this.$emit("fixQuestion");
    }
  }
};
</script>

<style lang="less" scoped>
.check-list {
  padding: 0px 30px 30px;
  display: flex;
  flex-direction: column;
  .check-item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }
  .check-item-desc {
    font-weight: 500;
  }
}
.check-icon {
  width: 20px;
  height: 20px;
}
.pass-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 30px;
}
.pass-icon-bg {
  background: #409eff;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}
.gou-icon {
  width: 28px;
  height: 28px;
}
.pass-desc {
  font-size: 24px;
  font-weight: 600;
}
.reject-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 30px;
}
.reject-icon-bg {
  background: #f56c6c;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}
.reject-desc {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 15px;
}
.close-icon {
  width: 28px;
  height: 28px;
}
.reject-reason {
  display: flex;
  width: 400px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 5px;
  &::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: block;
    margin-right: 5px;
    background: #666;
  }
}
.reject-example {
  display: flex;
  width: 400px;
  flex-wrap: wrap;
}
</style>
